import {Download} from "../../services/sincronizacao/download/Download";

export class Baixavel {
  download: Download<any>
  texto: string
  nome: string
  sincronizando = false
  ok: boolean

  constructor(download: Download<any>) {
    this.download = download
    this.nome = download.nomeEntidade
  }
}
